import React, { useState } from "react";
import { Info, X } from "lucide-react";

export const PayrollHeader = ({ styles: parentStyles, theme, language, setShowBenefitsModal }) => {
  const [showInfoModal, setShowInfoModal] = useState(false);

  const styles = {
    welcomeCard: {
      ...parentStyles?.header,
      backdropFilter: "blur(20px)",
      WebkitBackdropFilter: "blur(20px)",
      borderRadius: "24px",
      padding: "32px",
      marginTop: "-43px",
      marginBottom: "32px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      animation: "slideInDown 0.6s cubic-bezier(0.34, 1.56, 0.64, 1)",
      flexWrap: "wrap",
      gap: "24px",
      direction: language === "ar" ? "rtl" : "ltr",
    },
    contentSection: {
      flex: 1,
      minWidth: "250px",
    },
    welcomeTitle: {
      fontSize: "28px",
      fontWeight: "700",
      color: theme === "dark" ? "#f1f5f9" : "#1e293b",
      margin: "0 0 12px 0",
      letterSpacing: "-0.5px",
    },
    welcomeSubtitle: {
      fontSize: "15px",
      color: theme === "dark" ? "#cbd5e1" : "#64748b",
      margin: 0,
      fontWeight: "500",
    },
    infoButton: {
      background: theme === "dark"
        ? "linear-gradient(135deg, rgba(59, 130, 246, 0.15) 0%, rgba(37, 99, 235, 0.1) 100%)"
        : "linear-gradient(135deg, rgba(96, 165, 250, 0.1) 0%, rgba(59, 130, 246, 0.05) 100%)",
      border: theme === "dark"
        ? "1px solid rgba(59, 130, 246, 0.3)"
        : "1px solid rgba(59, 130, 246, 0.2)",
      width: "48px",
      height: "48px",
      borderRadius: "12px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      color: theme === "dark" ? "#60a5fa" : "#2563eb",
    },
    modal: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "rgba(0, 0, 0, 0.65)",
      backdropFilter: "blur(12px)",
      WebkitBackdropFilter: "blur(12px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
      padding: "20px",
      animation: "fadeIn 0.3s ease-out",
    },
    modalContent: {
      background: theme === "dark"
        ? "rgba(15, 23, 42, 0.95)"
        : "rgba(255, 255, 255, 0.98)",
      borderRadius: "24px",
      padding: "32px",
      maxWidth: "500px",
      width: "100%",
      border: theme === "dark"
        ? "1px solid rgba(148, 163, 184, 0.15)"
        : "1px solid rgba(0, 0, 0, 0.05)",
      boxShadow: theme === "dark"
        ? "0 20px 60px rgba(0, 0, 0, 0.4)"
        : "0 20px 60px rgba(0, 0, 0, 0.15)",
      animation: "slideUp 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)",
    },
    modalHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "24px",
    },
    modalTitle: {
      fontSize: "22px",
      fontWeight: "700",
      color: theme === "dark" ? "#f1f5f9" : "#1e293b",
      margin: 0,
    },
    closeButton: {
      background: "transparent",
      border: "none",
      cursor: "pointer",
      padding: "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "8px",
      transition: "all 0.2s ease",
      color: theme === "dark" ? "#94a3b8" : "#64748b",
    },
    modalBody: {
      fontSize: "15px",
      lineHeight: "1.7",
      color: theme === "dark" ? "#cbd5e1" : "#475569",
      whiteSpace: "pre-line",
    },
    modalOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 9998,
    },
  };

  return (
    <>
      <style>{`
        @keyframes slideInDown {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
      `}</style>

      <div className="nx-page-header" style={styles.welcomeCard}>
        <div style={styles.contentSection}>
          <h1 className="nx-page-title" style={styles.welcomeTitle}>
            {language === "ar" ? "إدارة المرتبات" : "Payroll Management"}
          </h1>
          <p className="nx-page-subtitle" style={styles.welcomeSubtitle}>
            {language === "ar" ? "إدارة رواتب وحزم مزايا الموظفين بكفاءة" : "Manage employee salaries and benefits packages efficiently"}
          </p>
        </div>
        {/* <button
          style={styles.infoButton}
          onClick={() => setShowBenefitsModal(true)}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = theme === "dark"
              ? "linear-gradient(135deg, rgba(59, 130, 246, 0.25) 0%, rgba(37, 99, 235, 0.2) 100%)"
              : "linear-gradient(135deg, rgba(96, 165, 250, 0.2) 0%, rgba(59, 130, 246, 0.15) 100%)";
            e.currentTarget.style.transform = "scale(1.05)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = theme === "dark"
              ? "linear-gradient(135deg, rgba(59, 130, 246, 0.15) 0%, rgba(37, 99, 235, 0.1) 100%)"
              : "linear-gradient(135deg, rgba(96, 165, 250, 0.1) 0%, rgba(59, 130, 246, 0.05) 100%)";
            e.currentTarget.style.transform = "scale(1)";
          }}
          title={language === "ar" ? "معلومات" : "Information"}
        >
          <Info size={24} />
        </button> */}
      </div>

      {showInfoModal && (
        <>
          <div
            style={styles.modalOverlay}
            onClick={() => setShowInfoModal(false)}
          />
          <div className="payroll-modal" style={styles.modal} onClick={() => setShowInfoModal(false)}>
            <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
              <div style={styles.modalHeader}>
                <h2 style={styles.modalTitle}>
                  {language === "ar" ? "حزمة المزايا الموظفين" : "Employee Benefits Package"}
                </h2>
                <button
                  style={styles.closeButton}
                  onClick={() => setShowInfoModal(false)}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = theme === "dark"
                      ? "rgba(148, 163, 184, 0.1)"
                      : "rgba(0, 0, 0, 0.05)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = "transparent";
                  }}
                >
                  <X size={24} />
                </button>
              </div>
              <div style={styles.modalBody}>
                {language === "ar"
                  ? "التأمين الطبي\nنشط | تغطية عائلة كاملة\nتغطية طبية شاملة للموظف وأفراد عائلته\n\nالتأمين الاجتماعي\nنشط | إلزامي من قبل الحكومة\nمعاش تقاعدي وتأمين عجز وبطالة\n\nالإجازة السنوية\n21 يوم متبقي | إجازة مدفوعة\nإجازة سنوية مدفوعة وفقاً لقانون العمل المصري\n\nالتدريب والتطوير\nمتاح | النمو المهني\nبرامج التطوير المهني وتعزيز المهارات"
                  : "Medical Insurance\nActive | Full Family Coverage\nFull medical coverage for employee and family members\n\nSocial Insurance\nActive | Government Mandated\nPension, disability, and unemployment insurance\n\nAnnual Leave\n21 days remaining | Paid Time Off\nAnnual paid vacation as per Egyptian labor law\n\nTraining & Development\nAvailable | Professional Growth\nProfessional development and skill enhancement programs"}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default PayrollHeader;